import React, { Component } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { mapStyles } from "../utils/mapStyles";
import ax from "../auth/axios";
import { API_ROOT } from "../utils/api-config";
let geocoder;
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/json",
  },
};
export class FulfillMapContainer extends Component {
  constructor(props) {
    super(props);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClicked = this.onMapClicked.bind(this);
    this.displayMarkers = this.displayMarkers.bind(this);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      places: [],
      stores: [],
    };
  }
  componentDidMount() {
    this.filterFulfillments();
  }

  filterFulfillments() {
    this.setState({
      places: this.props.fulfillments.filter((ful) => {
        return (
          ((ful.pickup && ful.shipfrom_latitude) ||
            (!ful.pickup && ful.shipto_latitude)) &&
          ful.name
        );
      }),
    });

    this.plotPoints();
  }
  plotPoints() {
    let locations = this.getPoints(geocoder);
    // console.log("locations", locations);

    let newPlaces = new Array();

    Promise.all(locations).then((returnVals) => {
      returnVals.forEach((latLng) => {
        const fulId = this.props.fulfillments.find(
          (place) => place.id == latLng[2]
        );

        const places = this.state.places.filter(
          (place) => place.id != latLng[2]
        );
        // console.log(places);
        if (fulId.pickup) {
          fulId.shipfrom_latitude = latLng[0];
          fulId.shipfrom_longitude = latLng[1];
        } else {
          fulId.shipto_latitude = latLng[0];
          fulId.shipto_longitude = latLng[1];
        }

        this.setState({
          places: [...this.state.places, fulId],
        });
        if (fulId.pickup) {
          this.getFromCoords(
            fulId.order_id,
            fulId.shipfrom_latitude,
            fulId.shipfrom_longitude
          );
        } else {
          this.getToCoords(
            fulId.order_id,
            fulId.shipto_latitude,
            fulId.shipto_longitude
          );
        }
      });
    });
  }

  getToCoords = (id, lat, long) => {
    const formData = new FormData();

    formData.append("order[id]", id);
    formData.append("order[shipto_latitude]", lat);
    formData.append("order[shipto_longitude]", long);
    ax.patch(`${API_ROOT}/orders/${id}`, formData, config).then(({ data }) =>
      console.log(data)
    );
  };
  getFromCoords = (id, lat, long) => {
    const formData = new FormData();
    formData.append("order[id]", id);
    formData.append("order[shipfrom_latitude]", lat);
    formData.append("order[shipfrom_longitude]", long);
    ax.patch(`${API_ROOT}/orders/${id}`, formData, config).then(({ data }) =>
      console.log(data)
    );
  };

  getAddressData() {
    let addressData = [];
    const filteredFulfillments = this.props.fulfillments.filter((ful) => {
      return (
        (!ful.pickup && !ful.shipto_latitude) ||
        (ful.pickup && !ful.shipfrom_latitude)
      );
    });
    // console.log(filteredFulfillments);

    for (let i = 0; i < filteredFulfillments.length; i++) {
      let location = filteredFulfillments[i].pickup
        ? `${
            filteredFulfillments[i].shipfrom_address1.includes("-")
              ? filteredFulfillments[i].shipfrom_address1.split("-")[1]
              : filteredFulfillments[i].shipfrom_address1
          } + ${filteredFulfillments[i].shipfrom_city}`
        : `${
            filteredFulfillments[i].shipto_address1.includes("-")
              ? filteredFulfillments[i].shipto_address1.split("-")[1]
              : filteredFulfillments[i].shipto_address1
          } + ${filteredFulfillments[i].shipto_city}`;
      addressData.push({ id: filteredFulfillments[i].id, location: location });
    }
    return addressData;
  }
  getPoints(geocoder) {
    let locationData = [];
    let addressData = this.getAddressData();
    for (let i = 0; i < addressData.length; i++) {
      console.log("address", addressData);

      locationData.push(
        this.findLatLang(addressData[i].location, geocoder, addressData[i].id)
      );
    }
    return locationData; // array of promises
  }

  findLatLang(address, geocoder, id) {
    return new Promise(function (resolve, reject) {
      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status === "OK") {
            console.log({ results });

            resolve([
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng(),
              id,
            ]);
          } else {
            reject(new Error("Couldnt't find the location " + address));
          }
        }
      );
    });
  }

  displayMarkers(stores) {
    return stores.map((place, index) => {
      var image =
        "https://maps.google.com/mapfiles/kml/shapes/road_shield3.png";
      const position = place.pickup
        ? {
            lat: place.shipfrom_latitude,
            lng: place.shipfrom_longitude,
          }
        : {
            lat: place.shipto_latitude,
            lng: place.shipto_longitude,
          };
      return (
        <Marker
          ref={(marker) => (this._marker = marker)}
          label={(index + 1).toString()}
          key={index}
          id={index}
          icon={place.entered_dc_at ? image : null}
          title={place.order_number}
          merchant={place.name}
          position={position}
          onClick={this.onMarkerClick}
        />
      );
    });
  }
  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };
  onMarkerClick(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  }

  render() {
    geocoder = new this.props.google.maps.Geocoder();
    let bounds = new google.maps.LatLngBounds();

    this.state.places.map((place) => {
      let position = place.pickup
        ? new google.maps.LatLng(
            place.shipfrom_latitude,
            place.shipfrom_longitude
          )
        : new google.maps.LatLng(place.shipto_latitude, place.shipto_longitude);
      bounds.extend(position);
      return bounds;
    });
    return (
      <div className="row" style={{ height: "90vh", width: "100%" }}>
        <div className="col-md-12">
          <Map
            google={this.props.google}
            fitBounds
            panBounds
            bounds={bounds}
            zoom={12}
            styles={mapStyles}
            onClick={this.onMapClicked}
            // initialCenter={{
            //   lat: this.state.lat,
            //   lng: this.state.lng,
            // }}
          >
            {this.displayMarkers(this.state.stores)}
            {this.displayMarkers(this.state.places)}
            <InfoWindow
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
            >
              <div>
                <h4>
                  {this.state.selectedPlace.merchant} -{" "}
                  {this.state.selectedPlace.title}
                </h4>
              </div>
            </InfoWindow>
          </Map>
        </div>
      </div>
      // </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCgImsLUsK-v_7T9gytx9fmfHyYL4HDnSQ",
})(FulfillMapContainer);
